import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import EnumSelect from "@/components/EnumSelect";
import {
  DATE_FORMAT_DATE,
  DATE_FORMAT_DATE_TIME,
} from "@/schemas/question/date-formats";

const DateFormatSelect = forwardRef<HTMLButtonElement, ControllerRenderProps>(
  (props, ref) => (
    <EnumSelect
      options={[DATE_FORMAT_DATE, DATE_FORMAT_DATE_TIME]}
      translationKey="dateFormatTypes"
      {...props}
      ref={ref}
    />
  ),
);

export default DateFormatSelect;
